import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const DndList = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`

export const DropIndicator = styled.div`
  display: none;
  position: absolute;
  top: 0;
  height: 100%;
  background-color: ${COLORS.accentRed};
  opacity: 0.3;
  border-radius: 4px;
  pointer-events: none;
`
